module.exports = __webpack_public_path__ + "img/Multi-account-3.63d0ed4a.png";